window.Superexpress = (function () {
    var selectors = {
        seCurrentBetplace: '[se-current_drawing_betplace]',
        seCurrentContent: '#se-current_drawing_content',
        seLastBetplace: '[se-last_drawing_betplace]',
        seLastContent: '#se-last_drawing_content',

        seShowBetForm: '#se-show_bet_form',
        seShowBetList: '#se-show_bet_list',
        showFileTab: '#se-showFile',
        showTextTab:'#se-showText',
        seBetFormControls: '#se-bet_form_controls',
        seShowPackageForm: '#se-show_package_form',

        seToggleBet: '[se-togglebet]',
        couponInfoToggle: '[coupon-info-toggle]',
        seShowBetsByVariantCount: '[se-show_bets_by_variantcount]',

        sePaginationLink: '[se-pagination_link]',
        sePaginationInput: '[se-pagination_input]',

        seSendBet: '[js-node="express-current__send-btn"]',

        seSendPackageBetBtn: '[js-node="se-send_package_bet_btn"]',
        packageBetTableRowInfo: '[package-bet-table-rowinfo]',
        packageBetTableMinSumCell: '[package-bet-table-minsum-cell]',
        packageBetTableCurrentSumCell: '[package-bet-table-currentsum-cell]',
        packageBetCoefs: '[package-bet-coefs]',
        packageBetCoupon: '[package-bet-coupon]',
        packageBetReset: '[bet-package-reset-btn]',
        packageBetConfirm: '[package-bet-confirm]',
        packageBetStatusContainer: '[package-bet-status-container]',
        packageBetPreviewToggle: "[package-bet-preview-toggle]",
        packageBetInfo: '[package-bet-info]',
        packageBetRemoveItem: '.superexpress-batch-bet__table-cell-remove',
        packageBetControls: '#superexpress-batch-bet-textarea',
        packageBetClear:".superexpress-switcher__button-reset",


        local: {
            betSumInput: '[js-node="express-current__bet-sum-input"]',
            errorPopup: '[js-node="superexpress-events__item-errors"]',
            currencySelect: '#express-current__currency-select',
            checkboxes: '[js-node="express-current__market-input"]',
            eventsRows: '[js-node="express-current__event-row"]',
            minBetSum: '[js-node="express-current__min-bet-sum"]',
            optionsCnt: '[js-node="express-current__opt-count"]',
            percentageHintCheckbox: '[js-node="express__percentage-hint-switcher"]',
            probabilityPercentsVals: '[js-node="express-current__probability-percent-value"]',
            poolDistVals: '[js-node="express-current__pool-dist-value"]',
            randomBtn: '[js-node="express__random-btn"]',
            resetBtn: '[js-node="express-current__reset-btn"]',
            notSelectedBtn: '[js-node="express-current__notselected-btn"]',
            activeStateSwitcher: '[js-node=express_active-state-switcher]',
            detailedBetLast: '[js-node=express_detailed-bet-last]',
            stateActiveResult: '[se-state_active_result]'
        }
    };

    var currency = 'RUB';

    var notSelectedPressed = false;
    var savedChoice = [];

    var state = {
        isPercentageHintVisible: true,
    };

    var getResultMessage = function (status, msg) {
        if (status !== 'error' && status !== 'success')
            return '';
        return [
            '<div class="feedback__success-body">',
            '<div class="feedback__success-icon"><div class="icon-balance-request-win-' + status + '"></div></div>',
            '<div class="feedback__success-text" style="margin: 0">' + msg + '</div>',
            '</div>'
        ].join('\n');
    };

    var getSuperexpressPageType = function () {
        if ($(selectors.seCurrentBetplace).length > 0)
            return 'current';
        else if ($(selectors.seLastBetplace).length > 0)
            return 'last';
        else
            return 'all';
    };

    var init = function () {
        switch (getSuperexpressPageType()) {
            case 'current':
                UIbinder.bind.current();
                checkedInputsStateHandler.load();
                calcForm();

                showPercentageHint(state.isPercentageHintVisible);
                $(selectors.local.percentageHintCheckbox).prop('checked', state.isPercentageHintVisible);
                break;
            case 'last':
                UIbinder.bind.last();
                break;
            default:
                UIbinder.bind.all();
                break;
        }
    };

    var dispose = function () {
        switch (getSuperexpressPageType()) {
            case 'current':
                UIbinder.unBind.current();
                break;
            case 'last':
                UIbinder.unBind.last();
                break;
            default:
                UIbinder.unBind.all();
                break;
        }
    };

    var actions = {
        filterBefore: function (element) {
            var body = app.body;
            app.enableLoading();

            if (body.find(selectors.seCurrentBetplace + ' ' + selectors.seShowBetList).is(element)) {
                $(selectors.seBetFormControls).hide();
                $(selectors.seShowBetForm).removeClass('active');
            }
            else if (body.find(selectors.seLastBetplace + ' ' + selectors.seShowBetList).is(element)) {
                $(selectors.seShowBetForm).removeClass('active');
            }
        },
        filterAfter: function (element) {
            app.disableLoading();
        },
        recalculatePackageBet: function () {
            let cntrlVal = $(selectors.packageBetControls).val();
            if (cntrlVal) {
                $('#resultstring').html(cntrlVal.split('\n').filter(x => x.trim().length > 0).length);  //кол-во строк
                $('#resultsimbols').html(cntrlVal.length);  //кол-во символов

                if (cntrlVal.length > 0) {
                    $('#superexpress-batch-bet-reset').removeClass('disabled');
                } else {
                    $('#superexpress-batch-bet-reset').addClass('disabled');
                }

                let found = cntrlVal.match(/^\d*/gm);
                let total = found.reduce(function (total, amountString) {
                    let amount = parseInt(amountString);
                    amount = isNaN(amount) ? 0 : amount;
                    return total + amount;
                }, 0);
                $('#sumBet').html(total);
            }
        },
        /*dispatch custom event for matoma purpose*/
        dispatchCustomSubmitEvent: function  (responseStatus = 'success') {
            const eventId = responseStatus === 'success' ? 'd-i10-e9' : 'd-i10-e10';
            document.dispatchEvent(new CustomEvent("mtmCustomEvent", {
                bubbles: true,
                detail: {
                    id: eventId,
                    responseStatus: responseStatus
                }
            }));
        }
    };

    var UIbinder = (function () {
        var body = app.body;

        function bindCurrent() {
            //#region LOCAL

            // Сбросить
            body.on('click', selectors.local.resetBtn, function () {
                $(selectors.local.errorPopup  + ':first').css( 'display', 'none');
                resetChoice();
                checkedInputsStateHandler.clearStorageForCurrentAccount();
                calcForm();
            });

            // Случайный выбор
            body.on('click', selectors.local.randomBtn, function () {
                $(selectors.local.errorPopup  + ':first').css( 'display', 'none');
                randomBtnClickHandler();
                checkedInputsStateHandler.addAll();
            });

            body.on('click', selectors.local.notSelectedBtn, function () {
                notSelectedPressed = !notSelectedPressed;
                if (notSelectedPressed) {
                    $(this).addClass('m-pressed');
                }
                else {
                    $(this).removeClass('m-pressed');
                }

            });

            // Подсказки в процентах
            body.on('change', selectors.local.percentageHintCheckbox, function () {
                showPercentageHint($(this).prop('checked'));
            });

            // выбор коэффициента
            body.on('click', selectors.local.checkboxes, function () {
                var input = $(this);
                var id = input.data('id');
                if (input.prop('checked')) {

                    checkedInputsStateHandler.add(id);

                    if (savedChoice.indexOf(id) < 0) {
                        savedChoice.push(id);
                    }

                    var savedCount = 0;

                    $(selectors.local.eventsRows).each(function () {

                        if ($(this).find(selectors.local.checkboxes + ':checked').length > 0) {
                            savedCount++;
                        }
                    });

                    if (savedCount >= globalAppSettings.seCount) {
                        $(selectors.local.notSelectedBtn).addClass('m-disabled');
                    }
                    else if (savedCount > 0) {
                        $(selectors.local.notSelectedBtn).removeClass('m-disabled');
                    }

                } else {

                    checkedInputsStateHandler.remove(id);

                    var index = savedChoice.indexOf(id);
                    if (index > -1) {
                        savedChoice.splice(index, 1);
                    }

                    savedCount = 0;

                    $(selectors.local.eventsRows).each(function () {

                        if ($(this).find(selectors.local.checkboxes + ':checked').length > 0) {
                            savedCount++;
                        }
                    });

                    if (savedCount < globalAppSettings.seCount) {
                        $(selectors.local.notSelectedBtn).removeClass('m-disabled');
                    }

                    if (savedCount === 0) {
                        $(selectors.local.notSelectedBtn).addClass('m-disabled');
                    }
                }

                calcForm();
                checkInputAndTooltip();
            });

            // ввод суммы ставки
            body.on('focus', selectors.local.betSumInput, function () {
                $(this).select();
            });
            body.on('keypress', selectors.local.betSumInput, function (e) {
                if (app.inputIsInteger(e) === false)
                    return false;
            });
            body.on('keyup', selectors.local.betSumInput, function () {
                if(!$(this).val().trim()) {
                    $(selectors.local.errorPopup  + ':first').css( 'display', 'none');
                    return;
                }
                checkInputAndTooltip();
                var val = app.stringToNumber($(this).val());

                validateForm();
                $(this).val(app.numberToString(val));
            });

            // выбор валюты
            body.on('change', selectors.local.currencySelect, function () {
                var newCurrency = $(this).val();

                if (currency !== newCurrency) {
                    var sumInput = $(selectors.local.betSumInput);
                    var betSum = app.stringToNumber(sumInput.val());

                    switch (newCurrency) {
                        case 'Bonuses':
                            sumInput.val(app.numberToString(betSum * window.globalAppSettings.bonusExchangeRate));
                            break;
                        case 'RUB':
                            var newSum = Math.floor(betSum / window.globalAppSettings.bonusExchangeRate);
                            sumInput.val(newSum > 1 ? app.numberToString(newSum) : 1);
                            break;
                    }

                    currency = newCurrency;
                    checkInputAndTooltip();
                }
            });

            // Подсветить результаты (Last.DetailedBetItem)
            body.on('change', selectors.local.activeStateSwitcher, function () {
                highlightBetActiveStates(this);
            });

            //#endregion

            //#region  CURRENT

            // кнопка "Текущий" v2.0
            body.on('click', selectors.seCurrentBetplace + ' ' + selectors.seShowBetForm, function () {
                var number = $(selectors.seCurrentBetplace).data('number');

                this.dispatchEvent(new CustomEvent("mtmCustomEvent", { bubbles: true, detail: { id: 'd-i10-e2', triggerText: $(selectors.seShowBetForm).text() } }));

                app.enableLoading();
                Ajax.postJson("/baltsystem/CurrentDrawingForm", {
                    data: { number: number },
                    success: function () {
                        calcForm();
                        checkedInputsStateHandler.load();
                        app.disableLoading();

                        showPercentageHint(state.isPercentageHintVisible);
                        $(selectors.local.percentageHintCheckbox).prop('checked', state.isPercentageHintVisible);
                    }
                });
                $(selectors.seBetFormControls).show();
                $(selectors.seShowBetList).removeClass('active');
                $(this).addClass('active');

                return false;
            });

            function restartPackageBet() {
                app.enableLoading();
                var drawingNumber = $(selectors.seCurrentBetplace).data('number');
                Ajax.postJson("/baltsystem/resetpackagebetform", {
                    data: { drawingNumber: drawingNumber },
                    success: function () {
                        app.disableLoading();
                        actions.recalculatePackageBet();
                    }
                });
            }

            body.on('click', selectors.seCurrentBetplace + ' ' + selectors.seShowPackageForm, function () {
                restartPackageBet();
            });


            body.on('click', selectors.seCurrentBetplace + ' ' + selectors.packageBetConfirm, function () {
                app.enableLoading();
                Ajax.postJson("/baltsystem/confirmpackagebet", {
                    success: function () {
                        app.disableLoading();
                    }
                })
            });

            body.on('click', selectors.seCurrentBetplace + ' ' + '.betpackage-help-trigger', function () {
                var helpEelement = $(selectors.seCurrentBetplace + ' ' + '#se-help_batch_main');
                var subelements = helpEelement.children('.superexpress-batch-bet__help-body');
                if (subelements.length > 0) {
                    subelements.each(function (index) {
                        var subelement = $(subelements[index]);
                        subelement.toggle();
                    });
                }
            });

            body.on('click', selectors.seCurrentBetplace + ' ' + '.superexpress-batch-bet__help-close-icon', function () {
                $('.superexpress-batch-bet__help').toggle();
            });

            body.on('click', selectors.seCurrentBetplace + ' ' + selectors.packageBetReset, function () {
                restartPackageBet();
            });

            body.on('click', selectors.seCurrentContent + ' ' + selectors.couponInfoToggle, function () {
                var couponNode = $(this).closest('[data-coupon-number]');
                var couponNumber = couponNode.attr('data-coupon-number');
                var isExpanded = couponNode.is('[state-expanded]');
                var betNode = couponNode.closest('[data-betnumber]');
                var betNumber = betNode.data('betnumber');
                var drawingNumber = $(selectors.seCurrentBetplace).data('number');
                var ajaxUrl = (isExpanded) ? '/baltsystem/getbriefcouponinfo' : '/baltsystem/getdetailedcouponinfo';
                app.enableLoading();
                Ajax.postJson(ajaxUrl, {
                    data: { drawingNumber: drawingNumber, betNumber: betNumber, couponNumber: couponNumber, isCurrent: true  },
                    success: function () {
                        app.disableLoading();
                    }
                });
            });


            // Expand/collapse bet in CurrentDrawingBetList v2.0
            body.on('click', selectors.seCurrentContent + ' ' + selectors.seToggleBet, function () {
                var betNode = $(this).closest('[data-betnumber]');
                var isExpanded = betNode.is('[state-expanded]');
                var betNumber = betNode.data('betnumber');

                var isPackageBet = $(this).is(selectors.packageBetInfo);
                var ajaxUrl = undefined;
                var drawingNumber = $(selectors.seCurrentBetplace).data('number');
                if (isPackageBet) {
                    ajaxUrl = (isExpanded) ? "/baltsystem/CurrentDrawingBet" : "/baltsystem/getcurrentdrawingdetailedpackagebet";
                }
                else {
                    ajaxUrl = (isExpanded) ? "/baltsystem/CurrentDrawingBet" : "/baltsystem/CurrentDrawingDetailedBet";
                }

                app.enableLoading();
                Ajax.postJson(ajaxUrl, {
                    data: { number: drawingNumber, betNumber: betNumber },
                    success: function () {
                        app.disableLoading();
                    }
                });
                return false;
            });

            body.on('click', selectors.packageBetStatusContainer + ' ' + selectors.packageBetPreviewToggle, function () {
                var couponNode = $(this).closest('[data-preview-packagebet-coupon]');
                var couponNumber = couponNode.attr('data-preview-packagebet-coupon');
                var isExpanded = couponNode.is('[state-expanded]');
                var ajaxUrl = (isExpanded) ? "/baltsystem/getcouponbriefinfo" : "/baltsystem/getcoupondetailedinfo";
                app.enableLoading();
                Ajax.postJson(ajaxUrl,
                    {
                        data: { couponId: couponNumber },
                        success: function () { app.disableLoading(); }
                    });
            });

            // отправить ставку
            body.on('click', selectors.seSendBet, function () {
                if (!validateForm())
                    return false;
                var formResults = getFormResults();
                var drawingNumber = $(selectors.seCurrentBetplace).data('number');
                var drawingTitle = $(selectors.seCurrentBetplace).data('title');
                if (currency === 'Bonuses') {
                    formResults.sum = Math.round(formResults.sum / window.globalAppSettings.bonusExchangeRate);
                }

                app.enableLoading();
                Ajax.postJson("/baltsystem/SubmitBet", {
                    data: { number: drawingNumber, moneyValue: formResults.sum, coefs: formResults.coefs, currency: currency },
                    success: function (data) {
                        var message = (data.result) ? getResultMessage('success', window.Localization.getString('Scripts_Shared_Modules.Superexpress_31', 'Ваше пари успешно принято.')) : getResultMessage('error', data.errorMessage);
                        var messageWin = new app.ModalWindow({
                            content: message,
                            title: drawingTitle,
                        });
                        if (data.result) {
                            actions.dispatchCustomSubmitEvent()

                            Ajax.getJson("/baltsystem/GetViewSet", {
                                data: { number: drawingNumber },
                                success: function () {
                                    currency = 'RUB';
                                    calcForm();
                                    messageWin.show();
                                    app.disableLoading();
                                    CustomSelect.init([selectors.local.currencySelect]);
                                    checkedInputsStateHandler.clearStorageForCurrentAccount();
                                    const updateSuperexpressControlsBehaviour = new CustomEvent('triggerSuperexpressPagerBehaviour', {
                                        bubbles: true,
                                    });
                                    document.dispatchEvent(updateSuperexpressControlsBehaviour);

                                }
                            });
                        }
                        else {
                            const RESPONSE_STATUS = 'error';
                            actions.dispatchCustomSubmitEvent(RESPONSE_STATUS)
                            messageWin.show();
                            app.disableLoading();
                        }
                    }
                });
                return false;
            });

            body.on('click', selectors.showFileTab, function () {
                $(this).addClass('m-active');
                $(selectors.showTextTab).removeClass('m-active');
                $('#fileUploadArea').show();
                $('#textUploadArea').hide();
            });

            body.on('click', selectors.showTextTab, function () {
                $(this).addClass('m-active');
                $(selectors.showFileTab).removeClass('m-active');
                $('#fileUploadArea').hide();
                $('#textUploadArea').show();
            });

            body.on('input', selectors.packageBetControls, function () {
                actions.recalculatePackageBet();
            });

            body.on('click', selectors.packageBetClear, function () {
                $(selectors.packageBetControls).val('');
                $(this).addClass('disabled');
            });
            //#endregion -- CURRENT --
        }

        function bindLast() {
            // кнопка "Результаты" v2.0
            body.on('click', selectors.seLastBetplace + ' ' + selectors.seShowBetForm, function (e) {
                this.dispatchEvent(new CustomEvent("mtmCustomEvent", { bubbles: true, detail: { id: 'd-i10-e2', triggerText: $(selectors.seShowBetForm).text() } }));

                var number = $(selectors.seLastBetplace).data('number');
                app.enableLoading();
                Ajax.postJson("/baltsystem/DrawingResult", {
                    data: { number: number },
                    success: function () {
                        app.disableLoading();
                    }
                });
                $(selectors.seShowBetList).removeClass('active');
                $(this).addClass('active');
                return false;
            });

            body.on('click', selectors.seLastContent + ' ' + selectors.couponInfoToggle, function () {
                var couponNode = $(this).closest('[data-coupon-number]');
                var couponNumber = couponNode.attr('data-coupon-number');
                var isExpanded = couponNode.is('[state-expanded]');
                var betNode = couponNode.closest('[data-betnumber]');
                var betNumber = betNode.data('betnumber');
                var drawingNumber = $(selectors.seLastBetplace).data('number');
                var ajaxUrl = (isExpanded) ? '/baltsystem/getbriefcouponinfo' : '/baltsystem/getdetailedcouponinfo';
                app.enableLoading();
                Ajax.postJson(ajaxUrl, {
                    data: { drawingNumber: drawingNumber, betNumber: betNumber, couponNumber: couponNumber, isCurrent: false },
                    success: function () {
                        app.disableLoading();
                    }
                });
            });

            // Expand/collapse bet in LastDrawingBetList v2.0
            body.on('click', selectors.seLastContent + ' ' + selectors.seToggleBet, function () {
                var betNode = $(this).closest('[data-betnumber]');
                var isExpanded = betNode.is('[state-expanded]');
                var betNumber = betNode.data('betnumber');
                var drawingNumber = $(selectors.seLastBetplace).data('number');
                var isPackageBet = $(this).is(selectors.packageBetInfo);
                var selectedVariantCount = isPackageBet ? parseInt($('[selected-variant-count]').attr('selected-variant-count')) : 0;
                var ajaxUrl = undefined;
                if (isPackageBet) {
                    ajaxUrl = (isExpanded) ? "/baltsystem/DrawingBet" : "/baltsystem/getlastdrawingdetailedpackagebet";
                }
                else {
                    ajaxUrl = (isExpanded) ? "/baltsystem/DrawingBet" : "/baltsystem/DrawingDetailedBet";
                }


                app.enableLoading();
                Ajax.postJson(ajaxUrl, {
                    data: { number: drawingNumber, betNumber: betNumber, selectedvariantcount: selectedVariantCount },
                    success: function () {
                        app.disableLoading();
                    }
                });
                return false;
            });

            // Подсветить результаты (Last.DetailedBetItem)
            body.on('change', selectors.local.activeStateSwitcher, function () {
                highlightBetActiveStates(this);
            });

            //#endregion -- LAST --
        }

        function unBindCurrent() {
            //LOCAL
            body.off('click', selectors.local.resetBtn)
                .off('click', selectors.local.randomBtn)
                .off('change', selectors.local.percentageHintCheckbox)
                .off('click', selectors.local.checkboxes)
                .off('focus', selectors.local.betSumInput)
                .off('keypress', selectors.local.betSumInput)
                .off('keyup', selectors.local.betSumInput)
                .off('change', selectors.local.activeStateSwitcher)
                .off('click', selectors.seCurrentBetplace + ' ' + selectors.seShowBetForm)
                .off('click', selectors.seCurrentBetplace + ' ' + selectors.seShowBetList)
                .off('click', selectors.seCurrentContent + ' ' + selectors.seToggleBet)
                .off('click', selectors.seCurrentContent + ' ' + selectors.sePaginationLink)
                .off('keypress', selectors.seCurrentContent + ' ' + selectors.sePaginationInput)
                .off('click', selectors.seSendBet);
        }

        function unBindLast() {
            //LAST
            app.body
                .off('click', selectors.seLastBetplace + ' ' + selectors.seShowBetForm)
                .off('click', selectors.seLastBetplace + ' ' + selectors.seShowBetList)
                .off('click', selectors.seLastContent + ' ' + selectors.seToggleBet)
                .off('click', selectors.seLastContent + ' ' + selectors.seShowBetsByVariantCount)
                .off('click', selectors.seLastContent + ' ' + selectors.sePaginationLink)
                .off('keypress', selectors.seLastContent + ' ' + selectors.sePaginationInput)
                .off('change', selectors.local.activeStateSwitcher);
        }

        return {
            bind: {
                current: function () {
                    unBindCurrent();
                    bindCurrent();
                },
                last: function () {
                    unBindLast();
                    bindLast();
                },
                all: function () {
                    return false;
                }
            },
            unBind: {
                current: unBindCurrent,
                last: unBindLast,
                all: function () {
                    return false;
                }
            }
        }

    }());

    //todo:'superexpressCheckedInputs' - переписать это порно superexpressData то сериализованный, то нет объект, суется в одну переменную WHYYYYYY??? и так везде, выделить в отдельные методы
    var checkedInputsStateHandler = (function () {
        var ids = [];

        function save() {
            var accountId = sessionStorage.getItem('accountId');
            var superexpressData = sessionStorage.getItem('superexpressCheckedInputs') || null;

            if (superexpressData) {
                superexpressData = JSON.parse(superexpressData);
                if (superexpressData == null) {
                    superexpressData = {};
                }
            } else {
                superexpressData = {};
            }

            superexpressData[accountId] = ids;

            sessionStorage.setItem('superexpressCheckedInputs', JSON.stringify(superexpressData));
        }

        function load() {
            var accountId = sessionStorage.getItem('accountId');
            var superexpressCheckedInputs = sessionStorage.getItem('superexpressCheckedInputs');

            if (superexpressCheckedInputs) {
                superexpressCheckedInputs = JSON.parse(superexpressCheckedInputs);
                if (superexpressCheckedInputs != null) {
                    if (superexpressCheckedInputs[accountId]) {
                        ids = superexpressCheckedInputs[accountId];

                        if (accountId !== 'unauthorized') {
                            superexpressCheckedInputs['unauthorized'] = [];
                            sessionStorage.setItem('superexpressCheckedInputs', JSON.stringify(superexpressCheckedInputs));
                        }

                    }
                    else if (superexpressCheckedInputs['unauthorized']) {
                        if (superexpressCheckedInputs['unauthorized'].length > 0) {
                            superexpressCheckedInputs[accountId] = superexpressCheckedInputs['unauthorized'];
                            superexpressCheckedInputs['unauthorized'] = [];

                            sessionStorage.setItem('superexpressCheckedInputs', JSON.stringify(superexpressCheckedInputs));

                            ids = superexpressCheckedInputs[accountId];
                        }
                    }
                }
            }


            setChecked();
        }

        function clearStorageForCurrentAccount() {
            var accountId = sessionStorage.getItem('accountId');
            var superexpressCheckedInputs = sessionStorage.getItem('superexpressCheckedInputs');

            if (superexpressCheckedInputs) {
                superexpressCheckedInputs = JSON.parse(superexpressCheckedInputs);
                if (superexpressCheckedInputs) {
                    superexpressCheckedInputs[accountId] = [];
                    delete superexpressCheckedInputs[accountId];
                }
            }

            ids = [];

            sessionStorage.setItem('superexpressCheckedInputs', JSON.stringify(superexpressCheckedInputs));
        }

        function setChecked() {
            var checkboxes = $(selectors.local.checkboxes);
            for (var i = 0; i < ids.length; i++) {
                checkboxes.filter('[data-id="' + ids[i] + '"]').prop('checked', true);
            }

            calcForm();
        }

        return {
            load: function () {
                load();
            },
            add: function (id) {
                if (ids.indexOf(id) < 0) {
                    ids.push(id);
                    save();
                }
            },
            remove: function (id) {
                var index = ids.indexOf(id);

                if (index > -1) {
                    ids.splice(index, 1);
                    save();
                }
            },
            addAll: function () {
                var inputs = [];

                $(selectors.local.checkboxes).filter(':checked').prop('checked', true).each(function () {
                    inputs.push($(this).data('id'));
                });

                ids = inputs;

                save();
            },
            clearStorageForCurrentAccount: clearStorageForCurrentAccount
        }
    }());

    var showPercentageHint = function (newState) {
        if (newState === true) {
            $(selectors.local.probabilityPercentsVals).removeClass('hidden');
            $(selectors.local.poolDistVals).removeClass('hidden');
        } else {
            $(selectors.local.probabilityPercentsVals).addClass('hidden');
            $(selectors.local.poolDistVals).addClass('hidden');
        }
        state.isPercentageHintVisible = newState;
    };

    var randomBtnClickHandler = function () {

        if (!notSelectedPressed) {
            resetChoice();
        }
        else {
            partialReset();
        }
        randomChoice();
        calcForm();
    };

    var resetChoice = function () {
        $(selectors.local.checkboxes).prop('checked', false);
        savedChoice = [];
        notSelectedPressed = false;
        $(selectors.local.notSelectedBtn).removeClass('m-pressed');
        $(selectors.local.notSelectedBtn).addClass('m-disabled');
    };

    var partialReset = function () {
        $(selectors.local.eventsRows).each(function () {

            checkboxes = $(this).find(selectors.local.checkboxes);

            checkboxes.each(function () {

                id = $(this).data('id');

                if (savedChoice.indexOf(id) < 0) {
                    $(this).prop('checked', false);
                }

            });
        });
    };


    var randomChoice = function () {
        const lowerBounds = [0, 40, 60];
        var rand, checkboxes;

        $(selectors.local.eventsRows).each(function () {

            if ($(this).find(selectors.local.checkboxes + ':checked').length === 0) {
                rand = Math.ceil((Math.random() * 100));
                checkboxes = $(this).find(selectors.local.checkboxes);

                for (var i = lowerBounds.length - 1; i >= 0; i--) {
                    if (rand >= lowerBounds[i]) {
                        checkboxes.eq(i).prop('checked', true);
                        var id = checkboxes.eq(i).data('id');
                        if (!notSelectedPressed && savedChoice.indexOf(id) < 0) { savedChoice.push(id); }
                        break;
                    }
                }
            }
        });

        if (!notSelectedPressed) { $(selectors.local.notSelectedBtn).addClass('m-disabled'); }
    };

    var calcForm = function () {
        var checkedOptionsCnt = 1,
            minBetSum = globalAppSettings.minSuperexpressBetSum || 30,
            betSumInput = $(selectors.local.betSumInput),
            checkedCnt = 0;

        $(selectors.local.eventsRows).each(function () {
            checkedCtn = $(this).find(selectors.local.checkboxes + ':checked').length;
            checkedOptionsCnt = checkedOptionsCnt * checkedCtn;
        });

        minBetSum = checkedOptionsCnt * minBetSum;

        $(selectors.local.optionsCnt).html(checkedOptionsCnt);
        $(selectors.local.minBetSum).html(minBetSum);


        var localMinBetSum = minBetSum;
        if (currency === 'Bonuses') {
            localMinBetSum *= window.globalAppSettings.bonusExchangeRate;
        }

        betSumInput.val(app.numberToString(localMinBetSum));

        validateForm();
    };

    var isBonusBet = function () {
        return currency === 'Bonuses';
    };

    var calcMinBetSum = function () {
        var minBetSum = parseInt($(selectors.local.minBetSum).html());
        return isBonusBet() ? minBetSum * window.globalAppSettings.bonusExchangeRate : minBetSum;
    }

    var getMinBetSumErrorText = function () {
        return 'Минимальная сумма пари составляет ' + calcMinBetSum() + (isBonusBet() ? ' бонусов' : ' руб.');
    };

    var checkInputAndTooltip = function () {
        if(validateSum()) {
            $(selectors.local.errorPopup  + ':first').css( 'display', 'none');
        } else {
            $(selectors.local.errorPopup + ':first').css( 'display', 'block');
            $(selectors.local.errorPopup + ':first').attr('bb-tool', getMinBetSumErrorText());
        }
    };

    var validateSum = function () {
        var betSum = app.stringToNumber($(selectors.local.betSumInput).val());
        return betSum >= calcMinBetSum();
    };

    var validateForm = function () {
        var result = validateSum();
        if(result) {
            $(selectors.local.eventsRows).each(function () {
                if ($(this).find(selectors.local.checkboxes + ':checked').length === 0) {
                    result = false;
                }
            });
        }
        sendBtnState(result);
        return result;
    };

    var getFormResults = function () {
        var coefs = [];

        $(selectors.local.checkboxes).each(function () {
            if ($(this).prop('checked')) {
                var id = $(this).data('id');
                var eventId = $(this).closest(selectors.local.eventsRows).data('eventid');
                coefs.push({
                    coefid: id,
                    eventId: eventId
                });
            }
        });

        return {
            'sum': app.stringToNumber($(selectors.local.betSumInput).val()),
            'coefs': coefs,
        };
    };

    var highlightBetActiveStates = function (switchNode) {
        switchNode = $(switchNode);
        var activeResultNodes = switchNode.closest(selectors.local.detailedBetLast).find(selectors.local.stateActiveResult);

        if (switchNode.prop('checked') === true) {

            let toActivate = activeResultNodes.filter('[data-isactive=True]');
            let toDeactivate = activeResultNodes.filter('[data-isactive=False]');

            toActivate.addClass('active');
            toDeactivate.addClass('inactive');
        } else {
            activeResultNodes.removeClass('active');
            activeResultNodes.removeClass('inactive');
        }
    };

    var sendBtnState = function (newState) {
        if (newState === true)
            $(selectors.seSendBet).removeClass('m-disabled');
        else
            $(selectors.seSendBet).addClass('m-disabled');
    };



    return {
        init: init,
        dispose: dispose,
        getFormResults: getFormResults,
        highlightBetActiveStates: highlightBetActiveStates,
        actions: actions
    };
}());